import React, { useState, useEffect } from 'react';
import { Card, Tabs, Tab, Spinner } from 'react-bootstrap';
import DanhSachDuyetHoSoHLDT from './DanhSachDuyetHoSoHLDT';
import DanhSachDuyetHoSoKHTH from './DanhSachDuyetHoSoKHTH';
import DanhSachDuyetHoSoThongKe from './DanhSachDuyetHoSoThongKe';
import { getRoleUser } from '@app/utils/httpClient';
import { role } from '@app/utils/define';

const DanhSachDuyetHoSoMenu = () => {
    const [key, setKey] = useState('hldt');
    const [userRole, setUserRole] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const fetchRoles = async () => {
            try {
                const roles = await getRoleUser();
                let normalizedRoles = [];
                if (typeof roles === 'string') {
                    normalizedRoles = [roles.toLowerCase()];
                } else if (Array.isArray(roles)) {
                    normalizedRoles = roles.map(r => r.toLowerCase());
                }
                setUserRole(normalizedRoles);

                const checkAdmin = normalizedRoles.includes(role.Admin);
                const checkBaseAccess = normalizedRoles.includes(role.APP_DANHSACHDUYETHOSO_ACCESS);
                const checkHldt = normalizedRoles.includes(role.HLDT_NHAN_VIEN);
                const checkKhth = normalizedRoles.includes(role.PHONG_KE_HOACH_TONG_HOP);

                if (checkAdmin || (checkBaseAccess && checkHldt)) {
                    setKey('hldt');
                } else if (checkBaseAccess && checkKhth) {
                    setKey('khth');
                }
            } catch (error) {
                console.error("Lỗi lấy quyền:", error);
            } finally {
                setIsLoading(false);
            }
        };
        fetchRoles();
    }, []);

    if (isLoading) {
        return (
            <div className="d-flex justify-content-center align-items-center" style={{ height: '50vh' }}>
                <Spinner animation="border" variant="primary" />
                <span className="ms-2 text-muted">Đang tải dữ liệu...</span>
            </div>
        );
    }

    const isAdmin = userRole.includes(role.Admin);
    const hasBaseAccess = userRole.includes(role.APP_DANHSACHDUYETHOSO_ACCESS);
    const canViewHLDT = isAdmin || (hasBaseAccess && userRole.includes(role.HLDT_NHAN_VIEN));
    const canViewKHTH = isAdmin || (hasBaseAccess && userRole.includes(role.PHONG_KE_HOACH_TONG_HOP));
    const hasAccess = isAdmin || canViewHLDT || canViewKHTH;

    if (!hasAccess) {
        return (
            <div className="container-fluid mt-5">
                <Card className="text-center p-5 shadow-sm border-0 mx-auto" style={{ maxWidth: '600px' }}>
                    <Card.Body>
                        <i className="fas fa-lock text-danger mb-3" style={{ fontSize: '4rem' }}></i>
                        <h4 className="text-danger fw-bold mt-2">Truy cập bị từ chối</h4>
                        <p className="text-muted">Bạn không có quyền truy cập vào trang này. Yêu cầu quyền <strong>app_danhsachduyethoso_access</strong>.</p>
                    </Card.Body>
                </Card>
            </div>
        );
    }

    return (
        <div className="container-fluid py-4">
            <Card style={{ borderRadius: '16px', border: 'none', boxShadow: '0 4px 12px rgba(0,0,0,0.05)' }}>
                <Card.Header className="bg-white border-bottom-0 pt-4 px-4">
                    <h4 className="mb-0 text-primary fw-bold">Danh sách duyệt hồ sơ y tế</h4>
                </Card.Header>
                <Card.Body className="px-4 pb-4">
                    <Tabs
                        id="danh-sach-duyet-ho-so-tabs"
                        activeKey={key}
                        onSelect={(k) => setKey(k)}
                        className="mb-0 custom-tabs-container"
                    >
                        {canViewHLDT && (
                            <Tab 
                                eventKey="hldt" 
                                title={
                                    <div className="d-flex align-items-center">
                                        <span>HLĐT</span>
                                    </div>
                                }
                            >
                                <div className="pt-3">
                                    {key === 'hldt' && <DanhSachDuyetHoSoHLDT />}
                                </div>
                            </Tab>
                        )}
                        {canViewKHTH && (
                            <Tab 
                                eventKey="khth" 
                                title={
                                    <div className="d-flex align-items-center">
                                        <span>KHTH</span>
                                    </div>
                                }
                            >
                                <div className="pt-3">
                                    {key === 'khth' && <DanhSachDuyetHoSoKHTH />}
                                </div>
                            </Tab>
                        )}
                        {(canViewHLDT || canViewKHTH) && (
                            <Tab 
                                eventKey="thong-ke" 
                                title={
                                    <div className="d-flex align-items-center">
                                        <i className="fas fa-list-alt me-2"></i>
                                        <span>Thống kê</span>
                                    </div>
                                }
                            >
                                <div className="pt-3">
                                    {key === 'thong-ke' && <DanhSachDuyetHoSoThongKe />}
                                </div>
                            </Tab>
                        )}
                    </Tabs>
                </Card.Body>
            </Card>

            <style>
                {`
                    .custom-tabs-container.nav-tabs {
                        border-bottom: 1px solid #dee2e6;
                        gap: 0;
                        padding: 0;
                        margin: 0;
                    }
                    .custom-tabs-container .nav-item {
                        margin-bottom: -1px;
                    }
                    .custom-tabs-container .nav-link {
                        border: 1px solid transparent;
                        border-top-left-radius: 8px;
                        border-top-right-radius: 8px;
                        color: #6c757d;
                        font-weight: 500;
                        padding: 12px 24px;
                        transition: all 0.2s ease;
                        background-color: #f8f9fa;
                        display: flex;
                        align-items: center;
                        margin-right: 4px;
                    }
                    .custom-tabs-container .nav-link:hover {
                        background-color: #e9ecef;
                        border-color: #dee2e6 #dee2e6 #fff;
                    }
                    .custom-tabs-container .nav-link.active {
                        color: #0d6efd;
                        background-color: #fff;
                        border-color: #dee2e6 #dee2e6 #fff;
                        border-bottom: 3px solid #0d6efd;
                    }
                    .custom-tabs-container .nav-link i {
                        font-size: 1.1rem;
                    }
                    .custom-tabs-container .nav-link.active i {
                        color: #0d6efd;
                    }
                `}
            </style>
        </div>
    );
};

export default DanhSachDuyetHoSoMenu;